import { authHeader, handleResponse } from '../helpers';
export const NumberGenerationService = {
    fetchNumberGenerationData

};

function fetchNumberGenerationData(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };

    return fetch(`${process.env.REACT_APP_API_URL}NumberGenerationRpt/GetNumberGenRpt`, requestOptions)
        .then(handleResponse);
}